import axios from 'axios';
import recaptchaHandler from "../recaptcha/recaptcha";

const $modalsButtons = document.querySelector('[data-n-modal]')

if ($modalsButtons) {
    modalsHandler()
}

function modalsHandler() {

    const $modals = document.querySelectorAll('.n-modal')
    const $background = document.querySelector('.n-modal__background')

    const $getAccountButton = document.querySelector('[data-n-modal="get-account"]')
    const $subscribeNewsButton = document.querySelector('[data-n-modal="subscribe-news"]')
    const $sendMailButtons = document.querySelectorAll('[data-n-modal="send-mail"]')

    const backgroundActiveClass = 'n-modal__background--active';
    const modalActiveClass = 'n-modal--active';

    document.addEventListener('click', (event) => {
        const $click = event.target

        if (!$click.closest('.n-modal') && !$click.classList.contains('n-modal') && !$click.classList.contains('n-modal__open-button')) {

            $modals.forEach(($modal) => {
                $modal.classList.remove(modalActiveClass)
            })

            $background.classList.remove(backgroundActiveClass)
        }

        if ($click.classList.contains('n-modal__close')) {
            $modals.forEach(($modal) => {
                $modal.classList.remove(modalActiveClass)
            })

            $background.classList.remove(backgroundActiveClass)
        }
    })

    $getAccountButton.addEventListener('click', () => {
        if (!recaptchaHandler()) return

        const $name = document.getElementById('closed-demo-name')
        const $email = document.getElementById('closed-demo-email')

        $modals.forEach(($modal) => {
            $modal.classList.remove(modalActiveClass)
        })
        document.querySelector('[data-n-modal-name="success"]').classList.add(modalActiveClass)
        $background.classList.add(backgroundActiveClass)

        axios.post(`/user/mail-subscribe/get-account`, {
            name: $name.value, email: $email.value
        }).then(() => {
            $name.value = '';
            $email.value = '';
        })

    })

    $subscribeNewsButton.addEventListener('click', () => {
        $modals.forEach(($modal) => {
            $modal.classList.remove(modalActiveClass)
        })
        document.querySelector('[data-n-modal-name="subscribe-news"]').classList.add(modalActiveClass)
        $background.classList.add(backgroundActiveClass)
    })

    const $sendSubscribeNewsButton = document.getElementById('subscribe-news-button')

    $sendSubscribeNewsButton.addEventListener('click', () => {
        if (!recaptchaHandler()) return

        const $email = document.getElementById('subscribe-news-input')

        $modals.forEach(($modal) => {
            $modal.classList.remove(modalActiveClass)
        })
        document.querySelector('[data-n-modal-name="success"]').classList.add(modalActiveClass)
        $background.classList.add(backgroundActiveClass)

        axios.post(`/user/mail-subscribe/subscribe-news`, {
            email: $email.value
        }).then(() => {
            $email.value = '';
        })
    })

    $sendMailButtons.forEach(($sendMailButton) => {
        $sendMailButton.addEventListener('click', () => {
            $modals.forEach(($modal) => {
                $modal.classList.remove(modalActiveClass)
            })

            setTimeout(() => {
                document.querySelector('[data-n-modal-name="send-mail"]').classList.add(modalActiveClass)
                $background.classList.add(backgroundActiveClass)
            }, 0)

        })
    })


    const $sendMailSendButton = document.getElementById('send-mail-button')

    $sendMailSendButton.addEventListener('click', () => {
        if (!recaptchaHandler()) return

        const $email = document.getElementById('send-mail-email')
        const $message = document.getElementById('send-mail-message')

        $modals.forEach(($modal) => {
            $modal.classList.remove(modalActiveClass)
        })
        document.querySelector('[data-n-modal-name="success"]').classList.add(modalActiveClass)
        $background.classList.add(backgroundActiveClass)

        axios.post(`/user/mail-subscribe/send-mail`, {
            email: $email.value,
            message: $message.value,
        }).then(() => {
            $email.value = '';
            $message.value = '';
        })
    })
}
